export default "__VITE_ASSET__5L5n6Ozi__"